module.exports = __webpack_public_path__ + "img/finalPage.c0e2c7d0.png";